<geaui-page-content-layout class="bookmarks-page">
  <ng-container page-header>
    <geaui-page-header
      pageTitle="Bookmarks"
      [hasBackArrow]="false"
      [withSidebar]="true"
    >
    </geaui-page-header>
  </ng-container>

  <ng-container page-content>
    <div
      class="bookmark-content geaui-grid geaui-sidebar-grid geaui-scrollable-table"
    >
      <div
        class="bookmark-filters geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12"
      >
        <geaui-search-bar-v2
          [id]="'search-bar'"
          [group]="searchForm"
          formName="search"
          [placeholder]="searchPlaceholder"
          [showBottomBorderOnly]="true"
          [hasSuggestions]="false"
          [hasProminentButton]="false"
          (valueChanged)="searchValueChanged($event)"
          (clearEvent)="searchValueChanged('')"
        >
        </geaui-search-bar-v2>
        <hrt-filter-chips
          [columnDefinitions]="columnDefinitions"
          [activeChipFilters]="activeChipFilters"
          [globalSearch]="'Bookmarks Search'"
          [tableId]="tableId"
          (chipRemoved)="onChipRemoved($event)"
        ></hrt-filter-chips>
      </div>
      <geaui-table-v3
        [tableId]="tableId"
        [columnDefinitions]="columnDefinitions"
        [data]="bookmarkItems"
        [totalRecords]="count"
        [loading]="isTableLoading"
        [isLandingPage]="true"
        [rowsClickable]="true"
        [isLandingPage]="true"
        [sortable]="true"
        [nonClickableColumns]="nonClickableColumnKeys"
        [noEntriesTitle]="'No Bookmarks Found'"
        (rowClicked)="onClick($event)"
        class="geaui-col-desktop-xl-start-7 geaui-col-desktop-xl-12 geaui-col-desktop-lg-12 geaui-col-desktop-md-12 geaui-col-tablet-lg-12 geaui-col-tablet-sm-12 geaui-col-phone-lg-8 geaui-col-phone-sm-4"
      ></geaui-table-v3>
    </div>
  </ng-container>
</geaui-page-content-layout>